import React from 'react';

interface Props {
  onPrev: () => void;
  onNext: () => void;
  canPrev: boolean;
  canNext: boolean;
}

export const NavArrows: React.FC<Props> = ({ onPrev, onNext, canPrev, canNext }) => (
  <>
    <button
      className={`bs-arrow bs-arrow--left${!canPrev ? ' bs-arrow--hidden' : ''}`}
      onClick={onPrev}
      aria-label="Previous slide"
      aria-disabled={!canPrev}
    >
      ‹
    </button>
    <button
      className={`bs-arrow bs-arrow--right${!canNext ? ' bs-arrow--hidden' : ''}`}
      onClick={onNext}
      aria-label="Next slide"
      aria-disabled={!canNext}
    >
      ›
    </button>
  </>
);
